import type { Format } from '#root/global.type';
import type { DecorativeTagColorType } from '../../DecorativeTag/types/decorativeTagColor.type';

export const FORMAT_OPTIONS: Record<Format, { name: Format; color: DecorativeTagColorType }> = {
  Hyper: {
    name: 'Hyper',
    color: 'celeste'
  },
  Super: {
    name: 'Super',
    color: 'peach'
  },
  City: {
    name: 'City',
    color: 'champagne'
  },
  Contact: {
    name: 'Contact',
    color: 'mint'
  }
};
